import React, { ReactElement } from 'react';
import Barcode from 'react-barcode';
import { useSelector } from 'react-redux';
import { ShoppingPassInfoInterface } from '../../interfaces/ShoppingPass.interface';
import { getSelectedClientFeature } from '../../store/featureSlice';
import './shoppingPass.css';

const ShoppingPassInfo = ({
  inStoreCheckoutText,
  encodedBarcode,
  last4Accountnumber,
  tokenNumber,
  selectedClientId,
}: ShoppingPassInfoInterface): ReactElement => {
  const features = useSelector((state: any) =>
    getSelectedClientFeature(state, selectedClientId),
  );
  const { accessToUiBarcode } = features.features;

  return (
    <div className="shopping-pass-card-info">
      <div className="shopping-pass-account-info">
        <div className="card-barcode-wrapper" data-testid="barcode">
          {accessToUiBarcode ? (
            <Barcode
              value={tokenNumber ? tokenNumber : ''}
              displayValue={false}
              height={Number.parseFloat('37')}
              width={Number.parseFloat('2')}
              renderer="img"
            />
          ) : (
            <img
              src={`data:image/svg+xml;base64,${encodedBarcode}`}
              alt="barcode"
              className="barcode-img"
            />
          )}
        </div>
        <div
          className="shopping-pass-account-number-value"
          data-testid="shopping-pass-account-number"
        >
          <div className="shopping-account-num-end">
            {last4Accountnumber && `*${last4Accountnumber}`}
          </div>
          <div className="shopping-pass-disclosure-wrapper">
            <div className="shopping-pass-disclosure-heading">
              {inStoreCheckoutText}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShoppingPassInfo;
